import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';

const BrandBar = observer(() => {
    const { device } = useContext(Context);

    return (
        <div className="d-flex flex-wrap gap-2 mt-3">
            {device.brands.map(brand => (
                <Card
                    key={brand.id}
                    className="p-2 mb-2"
                    style={{
                        cursor: 'pointer',
                        textAlign: 'center',
                        backgroundColor: brand.id === device.selectedBrand.id ? '#f1f1f1' : 'white',

                        border: brand.id === device.selectedBrand.id ? '1px solid #3939398a' : '1px solid #dee2e6'
                    }}
                    onClick={() => {
                        device.setSelectedBrand(brand);
                        device.setPage(1); // ← сброс на первую страницу
                    }}
                >
                    {brand.name}
                </Card>
            ))}
        </div>
    );
});

export default BrandBar;